import { useMutation, useQueryClient } from "@tanstack/react-query";
import { researchService } from "../services/research.service";
import { CreateChatPayload } from "../types/research.types";

export const useCreateChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateChatPayload) => researchService.createChat(payload),
    onSuccess: () => {
      // Invalidate chats query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["chats"] });
    },
  });
};
